import { Injectable } from '@angular/core';
import { UserMatterViewHistory } from '@models/userViewHistory';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as actions from './recently-viewed.actions';

@Injectable({
	providedIn: 'root',
})
export class RecentlyViewedDispatch {
	@Dispatch()
	Create = (userMatterViewHistory: UserMatterViewHistory): actions.Create =>
		new actions.Create(userMatterViewHistory);

	@Dispatch()
	UpdateViewedDocs = (
		matterId: string,
		viewedDocId: string,
	): actions.UpdateViewedDocs =>
		new actions.UpdateViewedDocs({ matterId, viewedDocId });

	@Dispatch()
	Pin = (matterId: string, pin: boolean): actions.Pin =>
		new actions.Pin({ matterId, pin });

	@Dispatch()
	HideFromTabs = (matterId: string): actions.HideFromTabs =>
		new actions.HideFromTabs({ matterId });
}
